import React, { useEffect, useState } from "react";
import {
  FiRefreshCw,
  FiSearch,
  FiActivity,
} from "react-icons/fi";
import api from "../../utills/api";

const AuditLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  const loadLogs = async () => {
    try {
      setLoading(true);

      /*
        Use the existing audit-log endpoint if available.
        No write/action APIs are introduced here.
      */
      const response = await api.get("/audit-logs");

      const data =
        response?.data?.data?.logs ||
        response?.data?.data ||
        response?.data ||
        [];

      setLogs(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Failed to load audit logs:", error);
      setLogs([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadLogs();
  }, []);

  const filteredLogs = logs.filter((log) => {
    const value = search.toLowerCase();

    return (
      !value ||
      log.action?.toLowerCase().includes(value) ||
      log.description?.toLowerCase().includes(value) ||
      log.userName?.toLowerCase().includes(value) ||
      log.user?.name?.toLowerCase().includes(value)
    );
  });

  const formatDate = (value) => {
    if (!value) return "—";

    return new Date(value).toLocaleString("en-IN", {
      dateStyle: "medium",
      timeStyle: "short",
    });
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h4 className="mb-1">Audit Logs</h4>
            <p className="text-muted mb-0">
              Review important activities performed in the
              organization.
            </p>
          </div>

          <button
            className="btn btn-light"
            onClick={loadLogs}
            disabled={loading}
          >
            <FiRefreshCw size={15} className="me-1" />
            Refresh
          </button>
        </div>

        <div className="card">
          <div className="card-body">
            <div className="input-group mb-4">
              <span className="input-group-text">
                <FiSearch size={16} />
              </span>

              <input
                type="search"
                className="form-control"
                placeholder="Search audit logs..."
                value={search}
                onChange={(e) =>
                  setSearch(e.target.value)
                }
              />
            </div>

            {loading ? (
              <div className="text-center py-5">
                Loading audit logs...
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table align-middle mb-0">
                  <thead>
                    <tr>
                      <th>Date & Time</th>
                      <th>User</th>
                      <th>Action</th>
                      <th>Description</th>
                      <th>Entity</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredLogs.length === 0 ? (
                      <tr>
                        <td
                          colSpan="5"
                          className="text-center text-muted py-5"
                        >
                          <FiActivity
                            size={28}
                            className="mb-2"
                          />
                          <div>
                            No audit logs available.
                          </div>
                        </td>
                      </tr>
                    ) : (
                      filteredLogs.map((log, index) => (
                        <tr
                          key={
                            log._id ||
                            log.id ||
                            index
                          }
                        >
                          <td>
                            {formatDate(
                              log.createdAt ||
                                log.timestamp ||
                                log.date
                            )}
                          </td>

                          <td>
                            {log.userName ||
                              log.user?.name ||
                              "System"}
                          </td>

                          <td>
                            <span className="badge bg-light text-dark">
                              {log.action || "—"}
                            </span>
                          </td>

                          <td>
                            {log.description || "—"}
                          </td>

                          <td>
                            {log.entityType ||
                              log.entity ||
                              "—"}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuditLogs;